if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    // SWIPER
	const swiperClass = '.swiper-js';

	document.querySelectorAll(swiperClass).forEach((slider, i) => {
		const dataOps = slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {};

		const swiperOps = {
			speed: 1000,
			loop: true,
			fadeEffect: { crossFade: true },
			allowTouchMove: true,
			breakpoints: {
				767: {
					allowTouchMove: false,
				},
			},
			on: {
				init: function (currentSwiper) {
					swiperADAduplicatedProcess(currentSwiper);
				},
			},
			pagination: {
				el: `.swiper-pagination-${i}`,
				clickable: true,
				renderBullet: function (index, className) {
					return `<span class="swiper-pagination-bullet">${index + 1}</span>`;
				},
			}
		};

		let combinedOps = Object.assign({}, swiperOps, dataOps);

		let sliderDots = document.createElement('div');
		sliderDots.classList.add("swiper-pagination",`swiper-pagination-${i}`);

		slider.setAttribute(`data-swiper${i}`, '');

		if(slider.classList.contains('has-swiper-dots')) {
			slider.appendChild(sliderDots);
		}
		const swiper = new Swiper(`[data-swiper${i}]`, combinedOps);

		swiper.on('slideChange', (currentSwiper) => {
			swiperADAduplicatedProcess(currentSwiper);
		});
	});

    $('.sym-slides').slick({
        accessibility: true
    });
    $('ul.slick-dots button').each(function(element, index){
        if($(this).text() < 10){
            $(this).html('0' + $(this).text());
            var label = $(this).text();
            console.log(label);
            $(this).attr('aria-label', label+' of '+ $(element).length);
        }
    });

    //vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		console.log('test');
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open');
				document.body.classList.add('no-scroll');
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}
	}

    // $('.sym-slides').each(function(element, index){
    //     if($(this).text() < 10){
    //         $(this).html('0' + $(this).text());
    //         var label = $(this).text();
    //         console.log(label);
    //         $(this).attr('aria-label', label+' of '+ $('ul.slick-dots button',element).length);
    //     }
    // });

})();